import { Controller } from '@hotwired/stimulus';
import { useMatchMedia } from 'stimulus-use';
import { MEDIA_QUERIES } from '../utils/constants';
import Swiper from 'swiper';
import { Navigation, Scrollbar, FreeMode } from 'swiper/modules';
import 'swiper/css';
// import 'swiper/scss/navigation';
import 'swiper/css/scrollbar';
import 'swiper/css/free-mode';
import 'swiper/css/grid';

export default class extends Controller {
  static targets = ['next', 'prev', 'slider', 'pagination'];

  static values = {
    component: Boolean,
    slidesPerView: Number
  };

  connect() {
    this.options = {
      modules: [Navigation, FreeMode, Scrollbar],
      watchOverflow: true,
      grabCursor: true,
      preventInteractionOnTransition: true,
      spaceBetween: 12,
      slidesPerView: this.slidesPerView || 3,
      roundLengths: false,
      navigation: this.hasNavigation,
      scrollbar: this.hasPagination
    };

    if (this.componentValue === true) {
      this.renderComponentSwiper();
    } else {
      useMatchMedia(this, {
        mediaQueries: MEDIA_QUERIES
      });
    }
  }

  isLarge = ({ name, media, matches, event }) => {
    this.enableSwiper();
  };

  isSmall = () => {
    // if (!matches) return;
    if (this.instance !== undefined) {
      this.sliderTarget.classList.remove('swiper-container');
      this.instance.destroy(true, true);
    }
  };

  renderComponentSwiper() {
    this.instance = new Swiper(this.sliderTarget, {
      ...this.options,
      watchOverflow: false,
      grabCursor: false,
      roundLengths: true,
      allowTouchMove: true,
      breakpoints: {
        // when window width is >= 640px
        768: {
          slidesPerView: this.slidesPerView || 2,
          spaceBetween: 24,
          allowTouchMove: false
        }
      },
      // cssMode: true,
      slidesPerView: 1,
      spaceBetween: 24
    });
  }

  enableSwiper() {
    this.sliderTarget.classList.add('swiper-container');

    this.instance = new Swiper(this.sliderTarget, {
      ...this.options,
      wrapperClass: 'carousel-wrapper'
    });
  }

  get hasNavigation() {
    if (this.hasNextTarget) {
      return {
        nextEl: this.nextTarget,
        prevEl: this.prevTarget,
        disabledClass: '-disabled'
      };
    } else {
      return false;
    }
  }

  get hasPagination() {
    if (this.hasPaginationTarget) {
      return {
        el: this.paginationTarget,
        hide: false
      };
    } else {
      return false;
    }
  }

  get slidesPerView() {
    return this.data.get('slides-per-view');
  }
}
